import {
  DASHBOARD_COUNT_REQ,
  DASHBOARD_COUNT_SUCCESS,
  DASHBOARD_COUNT_ERROR,
  GET_ORDER_REQ,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ALLCUSTOMER_REQ,
  GET_ALLCUSTOMER_SUCCESS,
  GET_ALLCUSTOMER_ERROR,
  ALLOW_CUSTOMER_REQ,
  ALLOW_CUSTOMER_SUCCESS,
  ALLOW_CUSTOMER_ERROR,
  RESTRICT_CUSTOMER_REQ,
  RESTRICT_CUSTOMER_SUCCESS,
  RESTRICT_CUSTOMER_ERROR,
  GET_ORDER_BY_ID_REQ,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_ERROR,
  ORDER_APPROVAL_REQ,
  ORDER_APPROVAL_SUCCESS,
  ORDER_APPROVAL_ERROR,
  GET_NOTIFICATION_REQ,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_ERROR,
  GET_LOGISTICS_REQ,
  GET_LOGISTICS_SUCCESS,
  GET_LOGISTICS_ERROR,
  GET_LOG_PARTNER_REQ,
  GET_LOG_PARTNER_SUCCESS,
  GET_LOG_PARTNER_ERROR,
  UPLOAD_DOC_REQ,
  UPLOAD_DOC_SUCCESS,
  UPLOAD_DOC_ERROR,
} from "../constants";

const initialState = {
  orderCount: {},
  isLodadingCount: false,
  errorCount: null,
  isOrder: false,
  orders: [],
  orderError: null,
  accounts: [],
  allowedAccount: false,
  metaData: {},
  allowed_for_credit_purchase: false,
  orderDetail: {},
  notification: [],
  logistics: [],
  log_partner: [],
  isUploadDoc: false,
};
export function DashboardReducer(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_COUNT_REQ: {
      return {
        ...state,
        isLodadingCount: true,
        orderCount: {},
      };
    }
    case DASHBOARD_COUNT_SUCCESS: {
      return {
        ...state,
        isLodadingCount: false,
        orderCount: action.payload,
      };
    }
    case DASHBOARD_COUNT_ERROR: {
      return {
        ...state,
        isLodadingCount: false,
      };
    }
    case GET_ORDER_REQ: {
      return {
        ...state,
        isOrder: true,
        orders: [],
      };
    }
    case GET_ORDER_SUCCESS: {
      return {
        ...state,
        isOrder: false,
        orders: action.payload,
        metaData: action.metaData,
      };
    }
    case GET_ORDER_ERROR: {
      return {
        ...state,
        isOrder: false,
      };
    }
    case GET_ALLCUSTOMER_REQ: {
      return {
        ...state,
        accounts: [],
        allowedAccount: true,
      };
    }
    case GET_ALLCUSTOMER_SUCCESS: {
      return {
        ...state,
        accounts: action.payload,
        allowedAccount: false,
        metaData: action.metaData,
      };
    }

    case GET_ALLCUSTOMER_ERROR: {
      return {
        ...state,
        allowedAccount: false,
      };
    }
    case ALLOW_CUSTOMER_REQ: {
      return {
        ...state,
      };
    }
    case ALLOW_CUSTOMER_SUCCESS: {
      return {
        ...state,
      };
    }
    case ALLOW_CUSTOMER_ERROR: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_REQ: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_SUCCESS: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_ERROR: {
      return {
        ...state,
      };
    }
    case GET_ORDER_BY_ID_REQ: {
      return {
        ...state,
      };
    }
    case GET_ORDER_BY_ID_SUCCESS: {
      return {
        ...state,
        orderDetail: action.payload,
      };
    }
    case GET_ORDER_BY_ID_ERROR: {
      return {
        ...state,
      };
    }

    case ORDER_APPROVAL_REQ: {
      return {
        ...state,
      };
    }
    case ORDER_APPROVAL_SUCCESS: {
      return {
        ...state,
        orderDetail: action.payload,
      };
    }
    case ORDER_APPROVAL_ERROR: {
      return {
        ...state,
      };
    }
    case GET_NOTIFICATION_REQ: {
      return {
        ...state,
      };
    }
    case GET_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        notification: action.payload,
      };
    }
    case GET_NOTIFICATION_ERROR: {
      return {
        ...state,
      };
    }

    case GET_LOGISTICS_REQ: {
      return {
        ...state,
      };
    }
    case GET_LOGISTICS_SUCCESS: {
      return {
        ...state,
        logistics: action.payload,
      };
    }
    case GET_LOGISTICS_ERROR: {
      return {
        ...state,
      };
    }

    case GET_LOG_PARTNER_REQ: {
      return {
        ...state,
      };
    }
    case GET_LOG_PARTNER_SUCCESS: {
      return {
        ...state,
        log_partner: action.payload,
      };
    }
    case GET_LOG_PARTNER_ERROR: {
      return {
        ...state,
      };
    }

    case UPLOAD_DOC_REQ: {
      return {
        ...state,
        isUploadDoc: true,
      };
    }
    case UPLOAD_DOC_SUCCESS: {
      return {
        ...state,
        isUploadDoc: false,
        // log_partner: action.payload,
      };
    }
    case UPLOAD_DOC_ERROR: {
      return {
        ...state,
        isUploadDoc: false,
      };
    }
    default:
      return state;
  }
}
